import { LOCALE } from "../../../properties/Locale";
import * as yup from "yup";

export const awardsAndRecognitionValidator = yup.object().shape({
  orgName: yup.string().required(LOCALE.name + LOCALE.required_field),
  awardName: yup.string().required(LOCALE.name + LOCALE.required_field),
  carrier: yup.object().shape({
    id: yup.string().required(LOCALE.carrier + LOCALE.required_field),
  }),
  awardType: yup.object().shape({
    id: yup.string().required(LOCALE.awardType + LOCALE.required_field),
  }),
  awardLevel: yup.object().shape({
    id: yup.string().required(LOCALE.awardLevel + LOCALE.required_field),
  }),
  eventType: yup.string().required(LOCALE.eventType + LOCALE.required_field),
  year: yup.string().required(LOCALE.year + LOCALE.required_field),
  proofs: yup.array().required(LOCALE.proof + LOCALE.required_field),
});

export const awardsAndRecognitionPointsValidator = yup.object().shape({
  points: yup.string().required(LOCALE.name + LOCALE.points),
  pointsChecked: yup.boolean().oneOf([true], "Must Approve Points"),
});
